module.exports = __webpack_public_path__ + "media/images/comment-47aab3a86776b901451a1052bc99d9b7.svg";